import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { queryFunction, queryKey } from './query';
import { SelectedFilters } from '@/components/FilterData/types';
import { normalizeSearchQuery } from '@/components/Search/utils';
import { UUID } from '@/api/generatedApi';

export const useFetchCrossTenantPartSearch = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  minThreshold,
  onError,
  enabled = true,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  minThreshold: number;
  selectedFilters?: SelectedFilters;
  onError?: (error: Error) => void;
  enabled?: boolean;
}) => {
  const normalizedSearchQuery = normalizeSearchQuery(searchQuery);

  return useDataGridFetcher({
    queryKey: parameters =>
      queryKey({
        assetId,
        assetTenantId,
        searchTenantId,
        searchQuery: normalizedSearchQuery,
        selectedFilters,
        minThreshold,
        ...parameters,
      }),
    queryFn: parameters =>
      queryFunction({
        assetId,
        assetTenantId,
        searchTenantId,
        searchQuery: normalizedSearchQuery,
        selectedFilters,
        minThreshold,
        ...parameters,
      }),
    onError,
    enabled,
  });
};
